document.querySelectorAll('details.et_pb_toggle').forEach(toggle => {
  const sync = () => {
    toggle.classList.toggle('et_pb_toggle_open', toggle.open);
    toggle.classList.toggle('et_pb_toggle_close', !toggle.open);
  };
  toggle.addEventListener('toggle', sync);
  sync();
});
document.querySelectorAll('.et_pb_tabs').forEach(tabs => {
  const controls = [...tabs.querySelectorAll('.et_pb_tabs_controls li')];
  const panels = [...tabs.querySelectorAll('.et_pb_tab')];
  const activate = index => {
    controls.forEach((control, i) => control.classList.toggle('et_pb_tab_active', i === index));
    panels.forEach((panel, i) => {
      panel.classList.toggle('et_pb_active_content', i === index);
      panel.style.display = i === index ? 'block' : 'none';
      panel.style.opacity = i === index ? '1' : '0';
    });
  };
  controls.forEach((control, i) => control.addEventListener('click', event => {
    event.preventDefault();
    activate(i);
  }));
  activate(Math.max(0, controls.findIndex(c => c.classList.contains('et_pb_tab_active'))));
});
document.querySelectorAll('.et_pb_slider').forEach(slider => {
  const slides = [...slider.querySelectorAll('.et_pb_slide')];
  const dots = [...slider.querySelectorAll('.et-pb-controllers a')];
  if (!slides.length) return;
  let index = Math.max(0, slides.findIndex(s => s.classList.contains('et-pb-active-slide')));
  const show = next => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle('et-pb-active-slide', i === index);
      slide.style.opacity = i === index ? '1' : '0';
      slide.style.zIndex = i === index ? '1' : '0';
    });
    dots.forEach((dot, i) => dot.classList.toggle('et-pb-active-control', i === index));
  };
  slider.querySelector('.et-pb-arrow-prev')?.addEventListener('click', event => {
    event.preventDefault(); show(index - 1);
  });
  slider.querySelector('.et-pb-arrow-next')?.addEventListener('click', event => {
    event.preventDefault(); show(index + 1);
  });
  dots.forEach((dot, i) => dot.addEventListener('click', event => {
    event.preventDefault(); show(i);
  }));
  show(index);
  const speedClass = [...slider.classList].find(name => /^et_slider_speed_\d+$/.test(name));
  if (slider.classList.contains('et_slider_auto') && speedClass) {
    const delay = Number(speedClass.split('_').pop());
    let timer;
    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => show(index + 1), delay);
    };
    if (!slider.classList.contains('et_slider_auto_ignore_hover')) {
      slider.addEventListener('mouseenter', () => clearInterval(timer));
      slider.addEventListener('mouseleave', start);
    }
    start();
  }
});
document.querySelectorAll('.ewd-ufaq-faq-div').forEach(faq => {
  const title = faq.querySelector('.ewd-ufaq-faq-title');
  const answer = faq.querySelector('.ewd-ufaq-faq-body');
  if (!title || !answer) return;
  title.tabIndex = 0;
  title.setAttribute('role', 'button');
  const toggle = () => {
    const open = title.getAttribute('aria-expanded') !== 'true';
    title.setAttribute('aria-expanded', String(open));
    answer.style.display = open ? 'block' : 'none';
  };
  title.addEventListener('click', toggle);
  title.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
  });
});
document.querySelectorAll('form[data-htl-inactive-form]').forEach(form => {
  if (!form.hasAttribute('action')) form.addEventListener('submit', event => event.preventDefault());
});

document.querySelectorAll('.mobile_menu_bar').forEach(control=>control.addEventListener('click',()=>{const nav=control.closest('.mobile_nav');if(!nav)return;if(!nav.querySelector('.et_mobile_menu')){const menu=document.querySelector('#top-menu')?.cloneNode(true);if(menu){menu.removeAttribute('id');menu.className='et_mobile_menu';nav.append(menu);}}const open=nav.classList.toggle('opened');nav.classList.toggle('closed',!open);}));
